/**
 * Format number with comma separators for thousands
 * @param {number} num - The number to format
 * @param {number} decimals - Number of decimal places (default: 0)
 * @returns {string} Formatted number string
 */
export const formatNumber = (num, decimals = 0) => {
    if (num === null || num === undefined || isNaN(num)) return '0';
    
    const number = Number(num);
    
    if (decimals > 0) {
        return number.toLocaleString('en-US', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    }
    
    return number.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
};

/**
 * Format currency (RM) with comma separators
 * @param {number} amount - The amount to format
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || isNaN(amount)) return 'RM 0.00';
    
    const number = Number(amount);
    return `RM ${number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })}`;
};

/**
 * Format number with unit (e.g., "1,000 pcs")
 * @param {number} num - The number to format
 * @param {string} unit - The unit to append
 * @returns {string} Formatted number with unit
 */
export const formatNumberWithUnit = (num, unit = '') => {
    const formatted = formatNumber(num);
    return unit ? `${formatted} ${unit}` : formatted;
};
